export enum MimeType {
    pptx = "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    docx = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    xlsx = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ppt = "application/vnd.ms-powerpoint",
    xls = "application/vnd.ms-excel",
    doc = "application/msword",
    pdf = "application/pdf",
    txt = "text/plain",
    csv = "text/csv",
    mp3 = "audio/mpeg",
    mp4 = "video/mp4",
    // m4a (MPEG-4 audio) — browsers report any of these for the same .m4a file,
    // and validation is an exact MIME match, so all variants must be listed.
    m4a = "audio/mp4",
    m4aX = "audio/x-m4a",
    m4aAlt = "audio/m4a"
}

export enum TrialMimeType {
    pptx = "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    docx = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    xlsx = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ppt = "application/vnd.ms-powerpoint",
    xls = "application/vnd.ms-excel",
    doc = "application/msword",
    pdf = "application/pdf",
    txt = "text/plain",
    csv = "text/csv",
    mp3 = "audio/mpeg",
    mp4 = "video/mp4",
    // m4a (MPEG-4 audio) — browsers report any of these for the same .m4a file,
    // and validation is an exact MIME match, so all variants must be listed.
    m4a = "audio/mp4",
    m4aX = "audio/x-m4a",
    m4aAlt = "audio/m4a"
}
